export default "__VITE_ASSET__498bc60a__"